import Axios from 'axios'
import {Config} from '../constants/Config'

const network = Axios.create({
  baseURL: Config.apiUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

if (Config.loggingRequests) {
  network.interceptors.request.use(request => {
    if (request.url?.indexOf('://')) {
      // Absolute URLs
      console.log(request.url)
    } else {
      // Relative URLs
      console.log(request.baseURL + '/' + request.url)
    }
    if (request.data) {
      console.log(JSON.stringify(request.data))
    }
    return request
  })
}

if (Config.loggingResponses) {
  network.interceptors.response.use(response => {
    console.log('RESPONSE_STATUS', response.status, response.statusText ?? '')
    if (response.data) {
      console.log(response.data)
    }
    return response
  })
}

network.interceptors.response.use(response => {
  if (typeof response.headers.pagination === 'string') {
    response.headers.pagination = JSON.parse(response.headers.pagination)
  }

  return response
})

if (Config.loggingNetworkErrors) {
  network.interceptors.response.use(
    response => response,
    function (error) {
      console.log(error.response)
      return Promise.reject(error)
    },
  )
}

export default network
